import { createApi } from '@core/fetch'
import http from '@core/fetch'

export default {
  getHallInfo: createApi(
    '/p/wedding/index.php/admin/APIHotelMerchant/hall_info'
  ),
  editHall: createApi.post('/p/wedding/index.php/admin/APIHotelMerchant/hall', {
    ignore: [undefined]
  }),
  // 高定标签列表
  getTopWeddingTag: () => http('/hps/admin/figure/topWedding/topLabel'),

  // 获取可选场地标签列表
  getHallMarksApi: createApi(
    '/p/wedding/index.php/Admin/APIHotelMerchant/hallMarks'
  )
}
